import { Injectable } from '@angular/core';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";

@Injectable({
  providedIn: 'root'
})
export class DataService {
z:any;
  constructor() { }

  returnee(whereis):any{

    let db = firebase.database();
 return db.ref('/'+whereis).once('value').then( (snapshot)=>{


     return this.z = snapshot.val();
     //hjgyfhd
console.log(this.z);

  })


  }
}
